var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advert"},[(_vm.adsPojo.adTitle)?_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.adsPojo.adTitle))]):_vm._e(),(_vm.adsPojo.adLink)?_c('a',{staticClass:"ad_img",style:(_vm.styleObject),attrs:{"href":_vm.adsPojo.adLink,"target":"_blank"}}):_c('a',{staticClass:"ad_img",style:(_vm.styleObject)})])
}
var staticRenderFns = []

export { render, staticRenderFns }